import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { PatientVisitsService } from 'src/app/modules/patient-visits/_services';
import * as CryptoJS from 'crypto-js';
import { HospitalService } from '../_services';


@Component({
  selector: 'app-download-report',
  templateUrl: './download-report.component.html',
  styleUrls: ['./download-report.component.scss']
})
export class DownloadReportComponent implements OnInit {

  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  language: any;
  user$: Observable<AuthModel>;
  RefreshToken;
  PatientId;
  // GuestId;
  VisitId;
  ReportName;
  VerifyReportModel;
  ReportNameEn;
  ReportNameAr;
  constructor(private HospitalService: HospitalService, public PatientVisitsService: PatientVisitsService, private authService: AuthService, private route: ActivatedRoute, private router: Router,
    private translationService: TranslationService, private auth: AuthService, private toast: HotToastService) {
    this.user$ = this.auth.currentUserSubject.asObservable();
  }
  ngOnInit(): void {

    this.VisitId = this.decryptParam(this.route.snapshot.params['visitId']);
    this.ReportName = this.route.snapshot.params['name'];
    this.PatientId = this.decryptParam(this.route.snapshot.params['patientId']);
    const sb = this.HospitalService.GetVerifyReportInfo(this.PatientId, this.VisitId).subscribe(res => {

      if (res.data != null && res.isSuccess) {
        this.VerifyReportModel = res.data;
      }
    });
    this.subscriptions.push(sb);
    this.GetReportName();
    // const sb = this.user$.subscribe(res => {
    //   if (res.userId) {
    //     if (res.isGuest && res.iqamaId != null && res.iqamaId != '') {
    //       this.GuestId = res.userId;
    //       this.PatientId = 0;

    //     }
    //     else {
    //       this.PatientId = res.userId;
    //       this.GuestId = 0;
    //     }
    //     this.RefreshToken = res.refreshToken;
    //   }
    // });
    // this.subscriptions.push(sb);
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.PatientVisitsService.isLoading$;
  }
  GetReportName() {
    switch (this.ReportName) {
      case 'DischargeSummaryReport':
        this.ReportNameAr = 'التحقق من تقرير الخروج';
        this.ReportNameEn = 'Discharge Summary Report Verification';
        break;
      case 'SickLeaveReport':
        this.ReportNameAr = 'التحقق من الإجازة المرضية';
        this.ReportNameEn = 'SickLeave Verification';
        break;
      case 'Prescription':
        this.ReportNameAr = 'التحقق من الوصفة الطبية';
        this.ReportNameEn = 'Prescription Verification';
        break;
      case 'LabReport':
        this.ReportNameAr = '  التحقق من تقرير المختبر';
        this.ReportNameEn = 'Laboratory Report Verification';
        break;
      case 'RadiologyReport':
        this.ReportNameAr = 'التحقق من تقرير الأشعة';
        this.ReportNameEn = 'Radiology Report Verification';
        break;
      case 'MedicalReport':
      this.ReportNameAr = 'التحقق من التقرير الطبي';
      this.ReportNameEn = 'Medical Report Verification';
      break;
    }
  }
  decryptParam(Param: string): string {
    const key = CryptoJS.enc.Utf8.parse('AAAA1ZUZ3BU:APA91bF3Za3oWbeovXhz'); // Replace with your own encryption key
    const iv = CryptoJS.enc.Utf8.parse('AAAA1ZUZ3BU:APA9'.substring(0, 16)); // Truncate or pad the IV to 16 bytes

    // Convert the hexadecimal string to bytes
    const encryptedBytes = CryptoJS.enc.Hex.parse(Param);

    // Decrypt the bytes
    const decryptedBytes = CryptoJS.AES.decrypt(
      { ciphertext: encryptedBytes },
      key,
      { iv: iv, padding: CryptoJS.pad.Pkcs7, mode: CryptoJS.mode.CBC }
    );

    // Convert the decrypted bytes to the original string
    const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  }

  // ViewReport() {
  //   this.VisitId = this.decryptParam(this.VisitId);
  //   this.PatientVisitsService.showLoader();
  //   switch (this.ReportName) {
  //     case 'DischargeSummaryReport':
  //       const sb1 = this.PatientVisitsService.GetDischargeSummaryReport(this.VisitId).pipe(
  //         catchError((errorMessage) => {
  //           this.PatientVisitsService.hideLoader();
  //           return of(errorMessage);
  //         })
  //       ).subscribe(res => {

  //         if (res.data && res.isSuccess) {
  //           this.PatientVisitsService.hideLoader();
  //           this.GetPDF(res.data, this.ReportName);
  //         }
  //         else if (res.error?.status == 401) {
  //           var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
  //           const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
  //             if (resl.userId && resl.userId != 0 && resl.userId != null) {
  //               this.ViewReport();
  //             }
  //             else {
  //               if (this.language == "ar") {
  //                 this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //               }
  //               else {
  //                 this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //               }
  //             }
  //           });
  //           this.subscriptions.push(RefreshToken);
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 404) {
  //           this.PatientVisitsService.hideLoader();
  //           this.toast.warning("<b>" + res.error.message + "</b>", { style: { padding: '20px' } });
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 500) {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //         else {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //       }, (err: any) => {
  //         this.PatientVisitsService.hideLoader();
  //         if (this.language == "ar") {
  //           this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //         }
  //         else {
  //           this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //         }
  //       });
  //       this.subscriptions.push(sb1);
  //       break;
  //     case 'MedicalReport':
  //       const sb2 = this.PatientVisitsService.GetMedicalReport(this.VisitId).pipe(
  //         catchError((errorMessage) => {
  //           this.PatientVisitsService.hideLoader();
  //           return of(errorMessage);
  //         })
  //       ).subscribe(res => {

  //         if (res.data && res.isSuccess) {
  //           this.PatientVisitsService.hideLoader();
  //           this.GetPDF(res.data, this.ReportName);
  //         }
  //         else if (res.error?.status == 401) {
  //           var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
  //           const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
  //             if (resl.userId && resl.userId != 0 && resl.userId != null) {
  //               this.ViewReport();
  //             }
  //             else {
  //               if (this.language == "ar") {
  //                 this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //               }
  //               else {
  //                 this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //               }
  //             }
  //           });
  //           this.subscriptions.push(RefreshToken);
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 404) {
  //           this.PatientVisitsService.hideLoader();
  //           this.toast.warning("<b>" + res.error.message + "</b>", { style: { padding: '20px' } });
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 500) {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //         else {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //       }, (err: any) => {
  //         this.PatientVisitsService.hideLoader();
  //         if (this.language == "ar") {
  //           this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //         }
  //         else {
  //           this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //         }
  //       });
  //       this.subscriptions.push(sb2);
  //       break;
  //     case 'SickLeaveReport':
  //       const sb3 = this.PatientVisitsService.GetSickLeaveReport(this.VisitId).pipe(
  //         catchError((errorMessage) => {
  //           this.PatientVisitsService.hideLoader();
  //           return of(errorMessage);
  //         })
  //       ).subscribe(res => {

  //         if (res.data && res.isSuccess) {
  //           this.PatientVisitsService.hideLoader();
  //           this.GetPDF(res.data, this.ReportName);
  //         }
  //         else if (res.error?.status == 401) {
  //           var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
  //           const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
  //             if (resl.userId && resl.userId != 0 && resl.userId != null) {
  //               this.ViewReport();
  //             }
  //             else {
  //               if (this.language == "ar") {
  //                 this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //               }
  //               else {
  //                 this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //               }
  //             }
  //           });
  //           this.subscriptions.push(RefreshToken);
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 404) {
  //           this.PatientVisitsService.hideLoader();
  //           this.toast.warning("<b>" + res.error.message + "</b>", { style: { padding: '20px' } });
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 500) {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //         else {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //       }, (err: any) => {
  //         this.PatientVisitsService.hideLoader();
  //         if (this.language == "ar") {
  //           this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //         }
  //         else {
  //           this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //         }
  //       });
  //       this.subscriptions.push(sb3);
  //       break;
  //     case 'Prescription':
  //       const sb4 = this.PatientVisitsService.GetPrescriptionReport(this.VisitId).pipe(
  //         catchError((errorMessage) => {
  //           this.PatientVisitsService.hideLoader();
  //           return of(errorMessage);
  //         })
  //       ).subscribe(res => {

  //         if (res.data && res.isSuccess) {
  //           this.PatientVisitsService.hideLoader();
  //           this.GetPDF(res.data, this.ReportName);
  //         }
  //         else if (res.error?.status == 401) {
  //           var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
  //           const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
  //             if (resl.userId && resl.userId != 0 && resl.userId != null) {
  //               this.ViewReport();
  //             }
  //             else {
  //               if (this.language == "ar") {
  //                 this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //               }
  //               else {
  //                 this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //               }
  //             }
  //           });
  //           this.subscriptions.push(RefreshToken);
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 404) {
  //           this.PatientVisitsService.hideLoader();
  //           this.toast.warning("<b>" + res.error.message + "</b>", { style: { padding: '20px' } });
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 500) {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //         else {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //       }, (err: any) => {
  //         this.PatientVisitsService.hideLoader();
  //         if (this.language == "ar") {
  //           this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //         }
  //         else {
  //           this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //         }
  //       });
  //       this.subscriptions.push(sb4);
  //       break;
  //     case 'LabReport':
  //       const sb5 = this.PatientVisitsService.GetLabReport(this.VisitId).pipe(
  //         catchError((errorMessage) => {
  //           this.PatientVisitsService.hideLoader();
  //           return of(errorMessage);
  //         })
  //       ).subscribe(res => {

  //         if (res.data && res.isSuccess) {
  //           this.PatientVisitsService.hideLoader();
  //           this.GetPDF(res.data, this.ReportName);
  //         }
  //         else if (res.error?.status == 401) {
  //           var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
  //           const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
  //             if (resl.userId && resl.userId != 0 && resl.userId != null) {
  //               this.ViewReport();
  //             }
  //             else {
  //               if (this.language == "ar") {
  //                 this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //               }
  //               else {
  //                 this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //               }
  //             }
  //           });
  //           this.subscriptions.push(RefreshToken);
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 404) {
  //           this.PatientVisitsService.hideLoader();
  //           this.toast.warning("<b>" + res.error.message + "</b>", { style: { padding: '20px' } });
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 500) {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //         else {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //       }, (err: any) => {
  //         this.PatientVisitsService.hideLoader();
  //         if (this.language == "ar") {
  //           this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //         }
  //         else {
  //           this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //         }
  //       });
  //       this.subscriptions.push(sb5);
  //       break;
  //     case 'RadiologyReport':
  //       const sb6 = this.PatientVisitsService.GetRadiologyReport(this.VisitId).pipe(
  //         catchError((errorMessage) => {
  //           this.PatientVisitsService.hideLoader();
  //           return of(errorMessage);
  //         })
  //       ).subscribe(res => {

  //         if (res.data && res.isSuccess) {
  //           this.PatientVisitsService.hideLoader();
  //           this.GetPDF(res.data, this.ReportName);
  //         }
  //         else if (res.error?.status == 401) {
  //           var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
  //           const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
  //             if (resl.userId && resl.userId != 0 && resl.userId != null) {
  //               this.ViewReport();
  //             }
  //             else {
  //               if (this.language == "ar") {
  //                 this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //               }
  //               else {
  //                 this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //               }
  //             }
  //           });
  //           this.subscriptions.push(RefreshToken);
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 404) {
  //           this.PatientVisitsService.hideLoader();
  //           this.toast.warning("<b>" + res.error.message + "</b>", { style: { padding: '20px' } });
  //         }
  //         else if (!res.error.data && !res.error.isSuccess && res.error.responseCode == 500) {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //         else {
  //           this.PatientVisitsService.hideLoader();
  //           if (this.language == "ar") {
  //             this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //           }
  //           else {
  //             this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //           }
  //         }
  //       }, (err: any) => {
  //         this.PatientVisitsService.hideLoader();
  //         if (this.language == "ar") {
  //           this.toast.error("<b>حدث خطأ</b>", { style: { padding: '20px' } });
  //         }
  //         else {
  //           this.toast.error("<b>An Error Occurred</b>", { style: { padding: '20px' } });
  //         }
  //       });
  //       this.subscriptions.push(sb6);
  //       break;

  //     default:
  //       if (this.language == "ar") {
  //         this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
  //       }
  //       else {
  //         this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
  //       }
  //       this.PatientVisitsService.hideLoader();
  //       break;
  //   }

  //   this.isLoading$ = this.PatientVisitsService.isLoading$;

  // }
  // b64toBlob(b64Data, contentType) {
  //   contentType = contentType || '';
  //   let sliceSize = 512;

  //   var byteCharacters = atob(b64Data);
  //   var byteArrays = [];

  //   for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
  //     var slice = byteCharacters.slice(offset, offset + sliceSize);

  //     var byteNumbers = new Array(slice.length);
  //     for (var i = 0; i < slice.length; i++) {
  //       byteNumbers[i] = slice.charCodeAt(i);
  //     }

  //     var byteArray = new Uint8Array(byteNumbers);

  //     byteArrays.push(byteArray);
  //   }

  //   var blob = new Blob(byteArrays, { type: contentType });
  //   return blob;
  // }
  // GetPDF(base64data, ReportName) {
  //   var blob = this.b64toBlob(base64data, "application/pdf");
  //   let a = document.createElement("a");
  //   document.body.appendChild(a);
  //   var url = window.URL.createObjectURL(blob);
  //   a.href = url;
  //   a.download = ReportName + ".pdf";
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  //   a.remove();
  //   this.PatientVisitsService.hideLoader();

  // }

}
